import img_download from "assets/img/download.svg";
import img_loading from "assets/img/loading.svg";

import { MenuItemButton } from "components/menu/MenuItemButton";
import { useDownloadAssignmentArchive } from "hooks/useDownloadAssignmentArchive";

export const MenuItemButtonDownload = ({ assignmentId }) => {
  const { isPending, download } = useDownloadAssignmentArchive();
  return (
    <MenuItemButton
      onClick={() => download(assignmentId)}
      disabled={isPending}
      title={!isPending ? "Скачать все файлы" : "Загрузка..."}
      iconSrc={!isPending ? img_download : img_loading}
    />
  );
};


